/** Full product name shown in headers and install prompts. */
export const APP_NAME = 'Chat By DataObserve'

/** Short mark for browser tab, loading states, and compact UI. */
export const APP_SHORT_NAME = 'Chat By DataObserve'

/** Compact boot / splash glyph (2–4 characters). */
export const APP_BOOT_MARK = 'DO'

/** Default document title before route-specific titles apply. */
export const APP_DOCUMENT_TITLE = APP_SHORT_NAME

/** Console log prefix for bootstrap and ops messages. */
export const APP_LOG_PREFIX = APP_SHORT_NAME

/**
 * Caption beside the DataObserve mark at the top of the home rail.
 *
 * Static for now. The design shows one word here and never varies it, so
 * nothing reads it from the session yet — point this at the workspace name or
 * the signed-in role once there is a field for it.
 */
export const BRAND_CAPTION = 'Chat'
